<template>
  <div class="index">
    <div class="table">
      <div v-if="status == 0">如果您想获取更精确的政策匹配服务，建议开通VIP服务</div>
      <el-table :data="tableData" border style="width: 100%" @row-click="openDetail">
        <el-table-column prop="title" label="政策名称" width="200"> </el-table-column>
        <el-table-column prop="dept" label="发文部门" width="200"> </el-table-column>
        <el-table-column prop="area" label="地区"> </el-table-column>
        <!-- <el-table-column prop="time" label="持续时间" width="180"> </el-table-column> -->
        <el-table-column prop="levelStar" label="政策等级" width="180"> </el-table-column>
        <el-table-column prop="amount" label="预计申报金额" width="180">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { blurResultAPI, DetailedResultAPI } from "@/api/index";
export default {
  props: ["status", "companyName", "form"],
  data() {
    return {
      radio1: "全部",
      tableData: [],
      value: 3,
    };
  },
  methods: {
    getResult() {
      if (this.status == 0) {
        blurResultAPI({
          name: this.companyName,
        }).then((res) => {
          this.tableData = res.data.list;
          // console.log(this.tableData);
          this.tableData = this.tableData.filter((item) => {
            return item.levelStar != "★★★★★";
          });
          // console.log(this.tableData);
          this.tableData = this.tableData.map((item) => {
            item.amount = item.amount + "万元";
            return item;
          });
          // console.log(this.tableData);
        });
      }
      if (this.status == 1) {
        DetailedResultAPI({
          ...this.form,
          token: localStorage.getItem("token"),
        }).then((res) => {
          this.tableData = res.data.data.list;
          this.tableData = this.tableData.map((item) => {
            item.amount = item.amount + "万元";
            return item;
          });
        });
      }
    },
    openDetail(row) {
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: { id: row.id, status: 2 },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  .header {
    margin-bottom: 20px;
    height: 60px;
    line-height: 60px;
    // background-color: aqua;
    display: flex;
    justify-content: flex-end;
    .check {
      margin-right: 5px;
    }
    input {
      height: 33px;
      line-height: 33px;
      padding-left: 10px;
      background-color: white;
      color: rgb(172, 167, 167);
      border: 1px solid rgb(215, 213, 213);
      margin-top: 12px;
      width: 200px;
      margin-right: 5px;
      outline: none;
    }
    button {
      width: 80px;
      height: 35px;
      line-height: 35px;
      margin-top: 12px;
      background-color: #4367fd;
      border: none;
      color: white;
    }
  }
}
</style>
